import { Time } from './Time'
import { Period } from './Period'
import { DateTime } from 'luxon'

export class VenueVelocity {
    constructor(
        public bookingLimit: number | null,
        public coverLimit: number | null,
        public dogFriendlyBookingLimit: number | null,
        public pramAccessibleBookingLimit: number | null,
        public highchairFriendlyBookingLimit: number | null,
        public dogFriendlyAllowedTimes: Period[] | null,
        public bookingSlotBookingLimits: BookingSlotVelocityLimit[],
        public bookingSlotCoverLimits: BookingSlotVelocityLimit[]
    ) { }

    bookingLimitAtDateTime(dateTime: Date, timeZone: string): number | null {
        const timeZoneDateTime = DateTime
            .fromJSDate(dateTime)
            .setZone(timeZone)
        return this.bookingSlotBookingLimits.find(limit => {
            const dayOfWeek = timeZoneDateTime.weekday
            if (limit.dayOfWeek !== dayOfWeek) {
                return false
            }
            const time = new Time(null, timeZoneDateTime.hour, timeZoneDateTime.minute)
            return limit.time.equals(time)
        })
            ?.limit ?? this.bookingLimit
    }

    coverLimitAtDateTime(dateTime: Date, timeZone: string): number | null {
        const timeZoneDateTime = DateTime
            .fromJSDate(dateTime)
            .setZone(timeZone)
        return this.bookingSlotCoverLimits.find(limit => {
            const dayOfWeek = timeZoneDateTime.weekday
            if (limit.dayOfWeek !== dayOfWeek) {
                return false
            }
            const time = new Time(null, timeZoneDateTime.hour, timeZoneDateTime.minute)
            return limit.time.equals(time)
        })
            ?.limit ?? this.coverLimit
    }
}

export class BookingSlotVelocityLimit {
    constructor(
        public dayOfWeek: number,
        public time: Time,
        public limit: number
    ) { }
}
